import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapActions, mapMutations, mapState } from 'vuex';
import Resource from '../components/resource.vue';
import UpdateResourceButton from './update-resource-button.vue';
import TagCascaderMulti from '@/components/TagCascaderMulti/index.vue';
import EditResourceButton from './edit-resource-button.vue';
import DownloadResourceButton from './download-resource-button.vue';
import categoryMixin from '@/views/creative/mixin/category.js';
import { language } from '@/common/storage';
import { hasPermission } from './auth.js';
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import TsPlayer from '../../../../../common/components/ts-player/index.vue';
import { v2Host } from '@/config/host';
import { getApiPath } from '@/common/api-proxy';
import getResponsiveBox from '@com/utils/get-responsive-box.js';
import { getToken } from '@/utils/auth.js';
import ImageFilter from '@com/components/image-filter/index.vue';
import { uploadFile } from '@/api/common/upload';
import { removeBase64Prefix } from '@com/utils/base64';
import { getFileName } from '@com/utils/file';
import filter from '@com/image/filter';
import { exchangeRgbaObjectToRgba } from '@com/utils/color';
import _ from 'lodash';
import ColorFilter from '@com/components/color-filter/index';
import ModelPreviewer from '../components/model-previewer.vue';
import { getFilterConfigForFilter as _getFilterConfigForFilter } from '@/store/creative/common/resource';
import { mergeVideoResource } from '@pt/api/gmaker/project';
import { addQueryString } from '@com/utils/url';
import isMaterialWarehouse from '@/common/is-warehouse.js';
import { isTextureResource } from '@/views/creative/utils';

var cookTagIds = function cookTagIds(ids) {
  return ids ? ids.split(',').map(function (item) {
    return Number(item);
  }) : [];
};

export default {
  mixins: [categoryMixin],

  components: {
    Resource: Resource,
    UpdateResourceButton: UpdateResourceButton,
    EditResourceButton: EditResourceButton,
    DownloadResourceButton: DownloadResourceButton,
    videoPlayer: videoPlayer,
    TsPlayer: TsPlayer,
    ImageFilter: ImageFilter,
    ColorFilter: ColorFilter,
    ModelPreviewer: ModelPreviewer
  },

  props: {
    resource: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    metaData: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      model: {
        tagIds: cookTagIds(this.resource.res_tag_ids)
      },
      filters: {
        hue: 0,
        saturation: 0,
        luminance: 0,
        blur: 0,
        red: 0,
        green: 0,
        blue: 0
      },
      activeColorType: 'single',
      currentColor: 'rgba(0, 0, 0, 1)',

      enableFillColor: false,
      imageFilterFilters: {},
      basicVideoResourceUrl: ''
    };
  },


  computed: _extends({}, mapState({
    projectId: function projectId(state) {
      return state.creative.template.id;
    },
    page: function page(state) {
      return state.creative.template.page;
    },
    resourceList: function resourceList(state) {
      return state.creative.template.templateConfig.resource;
    },
    permissionKeys: function permissionKeys(state) {
      return state.creative.template.permissions;
    },
    previewUrl: function previewUrl(state) {
      return state.creative.template.previewUrl;
    },
    hasMvPlayable: function hasMvPlayable(state) {
      return state.creative.template.hasMvPlayable;
    }
  }), {
    formItemList: function formItemList() {
      return [{
        label: '' + this.$t('playTurbo.custom.resourceUploader.tagLabel'),
        prop: 'tagIds',
        component: TagCascaderMulti,
        rules: [{
          required: true,
          message: '' + this.$t('playTurbo.custom.resourceUploader.tagPlaceholder'),
          trigger: 'change'
        }],
        params: {
          referenceAttrs: {
            style: 'width: 100%'
          },
          params: {
            type: this.category.res_type
          }
        }
      }];
    },
    showTagSelector: function showTagSelector() {
      return this.category.isNeedToAddTag && hasPermission({
        key: 'resource.select-tag',
        permissionKeys: this.permissionKeys
      });
    },
    langClass: function langClass() {
      if (language.get() === 'en') {
        return 'custom-en';
      }
      return '';
    },
    isTs: function isTs() {
      return this.isVideo && /\.ts$/.test(this.resource.file_url);
    },
    poster: function poster() {
      if (this.isVideo) {
        var baseUrl = '' + v2Host + getApiPath('/common/video/capture');
        return baseUrl + '?url=' + encodeURIComponent(this.resource.file_url) + '&w=200&_token=' + getToken();
      }
      return '';
    },
    extra: function extra() {
      return this.getExtra();
    },
    originalUrl: function originalUrl() {
      return this.extra.origin_file_url;
    },
    videoSize: function videoSize() {
      if (!this.isVideo) return {};
      if (this.extra) {
        return getResponsiveBox({
          maxHeight: 232,
          maxWidth: 232,
          width: this.extra.width,
          height: this.extra.height
        });
      }
      return {};
    },
    isNeedToRenderFilter: function isNeedToRenderFilter() {
      return this.originalUrl && this.isImage;
    },
    isUpdatable: function isUpdatable() {
      if (this.hasPermission('resource.basic-resource-updatable')) return true;
      return this.resource && this.resource.is_basic !== 1;
    },
    modelUrl: function modelUrl() {
      if (this.hasMvPlayable) {
        return addQueryString(this.previewUrl, {
          model_preview: 1,
          model_path: this.resource.real_file_path,
          disabled_preview_statistic: 1,
          disabled_preview_reference: 1,
          disabled_preview_grid: 1,
          disabled_preview_operation: 1,
          disabled_preview_animation: 1,
          startup_config: 1
        }).replace('loading=1', 'loading=2');
      }
      return '/common-viewer/?url=' + this.resource.extra.origin_file_url + '&type=model';
    },


    // 模型/贴图仅限内部账号下载
    showDownload: function showDownload() {
      return this.isInternalAccount || isMaterialWarehouse() || !(this.isModel || isTextureResource(this.resource));
    },
    showRefreshCover: function showRefreshCover() {
      return isMaterialWarehouse() && this.hasMvPlayable && this.isModel;
    }
  }),

  watch: {
    'model.tagIds': function modelTagIds(val) {
      var newResource = _extends({}, this.resource, {
        res_tag_ids: val.join(',')
      });
      this.updateCurrentResource(newResource);
      this.updateResource(newResource);
    },
    'resource.res_tag_ids': function resourceRes_tag_ids(val) {
      this.model.tagIds = cookTagIds(val);
    },
    'resource.id': function resourceId(val) {
      if (this.isImage) {
        this.filters = this.resource.extra.config.filters;
        this.enableFillColor = this.resource.extra.config.enableFillColor;
        this.imageFilterFilters = this.getFilterConfigForFilter(this.enableFillColor);
      }
      this.setBasicVideoResourceUrl();
    }
  },

  mounted: function mounted() {
    if (this.isImage) {
      this.filters = this.resource.extra.config.filters;
      this.enableFillColor = this.resource.extra.config.enableFillColor;
      this.imageFilterFilters = this.getFilterConfigForFilter(this.enableFillColor);
      this.imageFilterFilters = this.getFilterConfigForFilter(this.enableFillColor);
      this.currentColor = exchangeRgbaObjectToRgba({
        r: this.filters.red,
        g: this.filters.green,
        b: this.filters.blue,
        a: 1
      });
      console.log(this.currentColor);
    }
    this.setBasicVideoResourceUrl();
  },


  methods: _extends({}, mapMutations({
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResource: 'creative/template/updateCurrentResource',
    updateRefreshCover: 'creative/template/updateRefreshCover'
  }), mapActions({
    updateResource: 'creative/template/updateResource'
  }), {
    setBasicVideoResourceUrl: function setBasicVideoResourceUrl() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var isBasicVideoUrl, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.basicVideoResourceUrl = '';
                isBasicVideoUrl = _this.resource.extra.origin_file_url === _this.resource.file_url;

                if (!(_this.resource.extra.ext_audio_path && isBasicVideoUrl)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return mergeVideoResource({
                  id: _this.projectId,
                  path: _this.resource.file_path
                });

              case 5:
                res = _context.sent;

                if (res.data.code === 0) {
                  _this.basicVideoResourceUrl = _.get(res, 'data.data');
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getExtra: function getExtra() {
      return this.resource.extra || null;
    },
    getFilterConfigForFilter: function getFilterConfigForFilter(enableFillColor) {
      return _getFilterConfigForFilter(this.filters, enableFillColor);
    },
    uploadFileAfterAddFilter: function uploadFileAfterAddFilter(_ref) {
      var _this2 = this;

      var urls = _ref.urls;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, _res$data$data, file_path, md5, url, newResource;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return uploadFile({
                  file_base64: removeBase64Prefix(urls[0]),
                  filename: getFileName(_this2.originalUrl),
                  quality: 70
                });

              case 2:
                res = _context2.sent;
                _res$data$data = res.data.data, file_path = _res$data$data.file_path, md5 = _res$data$data.md5, url = _res$data$data.url;
                newResource = _extends({}, _this2.resource, {
                  file_path: file_path,
                  file_md5: md5,
                  file_url: url,
                  extra: _extends({}, _this2.resource.extra, {
                    config: _extends({}, _this2.resource.extra.config, {
                      filters: _this2.filters,
                      enableFillColor: _this2.enableFillColor
                    })
                  })
                });

                _this2.updateResource(newResource);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleImageFilterChange: function handleImageFilterChange(_ref2) {
      var _this3 = this;

      var filters = _ref2.filters;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.filters = _extends({}, _this3.filters, filters);
                _this3.imageFilterFilters = _this3.getFilterConfigForFilter(_this3.enableFillColor);
                _context3.next = 4;
                return _this3.addFilter();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleColorFilterChange: function handleColorFilterChange(val) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var rgba;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                rgba = val.rgba;

                _this4.filters = _extends({}, _this4.filters, {
                  red: rgba.r,
                  green: rgba.g,
                  blue: rgba.b
                });
                _this4.imageFilterFilters = _this4.getFilterConfigForFilter(_this4.enableFillColor);
                _this4.currentColor = exchangeRgbaObjectToRgba(_extends({}, rgba, {
                  a: 1
                }));
                _context4.next = 6;
                return _this4.addFilter();

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    addFilter: function addFilter() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var filters, urls;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                filters = _this5.getFilterConfigForFilter(_this5.enableFillColor);

                filters = _extends({}, _.omit(filters, ['blur']), {
                  blurRadius: filters.blur
                });
                _context5.next = 4;
                return filter({
                  urls: [_this5.originalUrl],
                  filters: filters
                });

              case 4:
                urls = _context5.sent;
                _context5.next = 7;
                return _this5.uploadFileAfterAddFilter({ urls: urls });

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    handleColorFilterToggle: function handleColorFilterToggle(val) {
      this.enableFillColor = val;
      this.imageFilterFilters = this.getFilterConfigForFilter(this.enableFillColor);
      this.addFilter();
    },
    handleRefreshCover: function handleRefreshCover() {
      this.updateRefreshCover(this.resource.id);
    }
  })
};